import React from 'react'

export const MouseIndicator = (params) => {
    return(
        <div className="mouseIndicator">
            <span className="indicator"></span>
        </div>
    )
}
